import { useSnackbar } from "notistack";

import { useCallback } from "react";

import usePlatform from "./usePlatform";

export default function () {
  const { enqueueSnackbar } = useSnackbar();
  const { isMobile } = usePlatform();

  const handleEnqueueSnackbar = useCallback(
    (message: string) => {
      enqueueSnackbar(message, {
        variant: "info",
        anchorOrigin: {
          vertical: isMobile ? "bottom" : "top",
          horizontal: isMobile ? "center" : "right",
        },
        autoHideDuration: 2000,
      });
    },
    [enqueueSnackbar, isMobile]
  );

  return {
    enqueueSnackbar: handleEnqueueSnackbar,
  };
}
